import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { FC, useEffect, memo, useRef, useMemo } from "../../../lib/teact/teact";
import InfiniteScroll from "../../ui/InfiniteScroll";
import ListItem from "../../ui/ListItem";
import { ReportType } from "../redux/TongHopSlice";
import Loading from "../ui/loading";
import { isCuPhapMn } from "../utils/common";
import RptDetailsItem from "./NhanVeItem";
import { NhanVeItemData } from "./workingTypes";
import './NhanVeItem.scss'
import NhanVeItemGroupTotal from "./NhanVeItemGroupTotal";
type OwnProps = {
    // reportType: ReportType;
    payload: any;
    selectedReport: ReportType;
    isLoading: boolean;
    // triggerTime: string;
}
/*Nhận về, chuyển đi, giữ lại*/
const TongHopPage: FC<OwnProps> = ({
    payload,
    selectedReport,
    isLoading,
}) => {
    const contentRef = useRef<HTMLDivElement>(null) || undefined;
    useEffect(() => {
        // Lấy chiều cao màn hình
        // const screenHeight = window.innerHeight// || document.documentElement.clientHeight || document.body.clientHeight;


        // const divAHeight = document.getElementById('content-screen')!.offsetHeight;


        // const divHeader = document.getElementById('header-screen')!.offsetHeight;


        // const divCHeight = screenHeight - divHeader - 127 ;


        // contentRef.current!.style.height = divCHeight + 'px';
        // console.log(contentRef.current!.style.height)
    }, [isLoading])
    switch (selectedReport) {
        case 'NhanVe':

            break;
        case 'ChuyenDi':
            break;
    }
    if (isLoading)
        return (
            <div ref={contentRef} id="data-screen">
                <Loading />
            </div>

        )
    const buildListIds = useMemo(() => {
        const tmp: number[] = []
        payload.data.map((item, index) => tmp.push(index))
        return tmp
    }, [payload.data])
    const [viewportIds, getMore] = useInfiniteScroll(undefined, buildListIds, false, 100);
    let stt = 0;
    let preLoaiCuoc = ""
    return (
        <div ref={contentRef} id="data-screen" className="th-data-screen">
            <ListItem key={'litem:' + "header-0"} style="width:100%"
                className="chat-item-clickable contact-list-item">
                <div className={isCuPhapMn() ? "th-grid-nhan-ve" : "th-grid-nhan-ve-mb"}>
                    {isCuPhapMn() ?
                        <div className="dai-title">
                            Đài
                        </div> :
                        <div  >
                            Stt
                        </div>
                    }
                    <div>
                        Loại
                    </div>
                    <div className=" th-left-align">
                        Số
                    </div>
                    <div className=" th-left-align">
                        Trúng
                    </div>
                    <div className={" th-right-align"}>
                        Điểm
                    </div>
                </div>
            </ListItem>
            <InfiniteScroll items={viewportIds} onLoadMore={getMore}
                className="chat-list custom-scroll"
                style="height:100%;"
            >
                {
                    viewportIds && viewportIds.map((it, index) => {
                        const item: NhanVeItemData = payload.data[it]
                        if (preLoaiCuoc != item.loaiCuocId) {
                            stt = 0
                        }
                        preLoaiCuoc = item.loaiCuocId
                        stt++
                        return (<div key={it}>
                            <ListItem className="Listitem-button-nopadding-all" style="width:100%">
                                <RptDetailsItem dataItem={item} index={item.stt} />
                            </ListItem>
                            {
                                item.lastItem && <NhanVeItemGroupTotal data={payload} curItem={item} />
                            }
                        </div>)
                    })
                }
            </InfiniteScroll>
        </div>
    );
};

export default memo(TongHopPage);
